import { Box, Divider, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../../../../api/hooks/useColors";
import TextButton from "../../../../../../../../components/buttons/TextButton";
import {
  ActivityLogType,
  RemediationType,
} from "../../../../../../../../utils/constants";
import {
  getPrettyDateTime,
  useLocalTime,
} from "../../../../../../../../utils/timestamp";
import UndoModal from "../UndoModal";

import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../../../../../api/hooks/useAPI";
import ChipColor from "../../../../../../../remediation/plan/components/ChipColor";
import { ReactComponent as RightArrowIcon } from "../../../../../../../stack/environment/icons/arrow_icons/arrow-right-currentColor-24.svg";

export default function AutoRemediationHistoryLog({
  auditLog,
  remediation,
  isMostRecentLog,
}) {
  const colors = useColors();
  const { trackEvent } = useAPI();
  const [, setSearchParams] = useSearchParams();
  const [showUndoModal, setShowUndoModal] = useState(false);
  const showLocalTime = useLocalTime();

  const handleViewGap = () => {
    trackEvent(
      `User clicked on view gap ${auditLog.remediation_id} button in auto-remediation history`
    );
    setSearchParams({
      remediation: auditLog.remediation_id,
    });
  };

  return (
    <>
      <Box display="flex" flexDirection="column" gap={1} padding="8px 0 0 8px">
        <Divider sx={{ borderColor: colors.divider }} />
        <Box
          display="flex"
          flexDirection="column"
          padding="8px 0 8px 8px"
          gap={1}
        >
          <Box height="24px" display="flex" justifyContent="space-between">
            <Typography variant="subtitle2">
              Applied Remediation Details
            </Typography>
            {isMostRecentLog &&
              auditLog.log_type !== ActivityLogType.ROLLED_BACK && (
                <TextButton
                  color="primary"
                  size="small"
                  onClick={() => setShowUndoModal(true)}
                >
                  Rollback this remediation
                </TextButton>
              )}
          </Box>
          <Box display="flex" width="100%" paddingY="8px">
            <Box
              display="flex"
              width="100%"
              height="54px"
              gap={2}
              justifyContent="space-between"
            >
              <Box display="flex" gap={4}>
                <Box display="flex" flexDirection="column" gap="14px">
                  <Typography variant="body2" color={colors.text_secondary}>
                    Approved by
                  </Typography>
                  <Typography
                    variant="body2"
                    noWrap
                    sx={{
                      maxWidth: 150,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {auditLog.user_display_name}
                  </Typography>
                </Box>
                <Divider
                  orientation="vertical"
                  sx={{ borderColor: colors.divider }}
                />
                <Box display="flex" flexDirection="column" gap="14px">
                  <Typography variant="body2" color={colors.text_secondary}>
                    Applied On
                  </Typography>
                  <Typography
                    variant="body2"
                    noWrap
                    sx={{
                      maxWidth: 160,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {getPrettyDateTime(
                      auditLog.log_timestamp.timestamp_utc,
                      showLocalTime
                    )}
                  </Typography>
                </Box>
                <Divider
                  orientation="vertical"
                  sx={{ borderColor: colors.divider }}
                />
                <Box display="flex" flexDirection="column" gap="14px">
                  <Typography variant="body2" color={colors.text_secondary}>
                    Priority
                  </Typography>
                  <ChipColor
                    value={remediation.priority}
                    type={RemediationType.REMEDIATION_PRIORITY}
                  />
                </Box>
                <Divider
                  orientation="vertical"
                  sx={{ borderColor: colors.divider }}
                />
                {auditLog.total_affected_entities_in_gap && (
                  <>
                    <Box display="flex" flexDirection="column" gap="14px">
                      <Typography
                        variant="body2"
                        color={colors.text_secondary}
                        noWrap
                      >
                        Remediation Scope
                      </Typography>
                      <Typography
                        variant="body2"
                        noWrap
                        sx={{
                          maxWidth: 150,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {`${auditLog.remediated_entities_count} of ${
                          auditLog.total_affected_entities_in_gap
                        } ${
                          auditLog.total_affected_entities_in_gap === 1
                            ? "entity"
                            : "entities"
                        }`}
                      </Typography>
                    </Box>
                    <Divider
                      orientation="vertical"
                      sx={{ borderColor: colors.divider }}
                    />
                  </>
                )}
                <Box display="flex" flexDirection="column" gap="14px">
                  <Typography variant="body2" color={colors.text_secondary}>
                    Gap ID
                  </Typography>
                  <Box
                    display="flex"
                    gap={1}
                    alignItems="center"
                    position="relative"
                    top="-6px"
                  >
                    <Typography variant="body2">
                      #{auditLog.remediation_id}
                    </Typography>
                    <TextButton
                      color="inherit"
                      size="small"
                      onClick={handleViewGap}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        paddingX="8px"
                      >
                        <Typography
                          variant="caption"
                          color={colors.button_text_inherit_enabled_text}
                        >
                          View
                        </Typography>
                        <RightArrowIcon
                          width="16px"
                          style={{
                            color: colors.button_text_inherit_enabled_text,
                          }}
                        />
                      </Box>
                    </TextButton>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <UndoModal
        showUndoModal={showUndoModal}
        setShowUndoModal={setShowUndoModal}
        log={auditLog}
      />
    </>
  );
}
